import { EasmScanConfigurationWebComponent } from './component/EasmScanConfigurationWebComponent';
import { WEB_COMPONENT_EASM_SCAN_CONFIGURATION } from '../../../webcomponents.constants';

export { EasmScanConfigurationWebComponent };

window.customElements.define(WEB_COMPONENT_EASM_SCAN_CONFIGURATION, EasmScanConfigurationWebComponent);
